
GP.GPMod('Chat.Gui', function(self) {
    var _conf, _data, _vchat, _apis, _util, _events,
        _info, _log, _warn, _error, _trace,
        _timers, _vent, _cometD;

    this.on('before:start', function() {
        var chat_module  = self.app.module("Chat");
        chat_module.gui = _gui;
    });

    self.init_module = function() {
        var chat_module   = self.app.module("Chat");

        _conf   = chat_module.conf;
        _data   = chat_module.data;
        _apis   = chat_module.apis;
        _events = chat_module.events;
        _util   = chat_module.util;
        _vchat  = chat_module.vchat;

        _vent  = self.vent;
        _info  = self.app.Util.info;
        _log   = self.app.Util.log;
        _warn  = self.app.Util.warn;
        _error = self.app.Util.error;
        _trace = self.app.Util.trace;

        _cometD = $.cometd;
        _timers = GP.Util.timers;
    };


    var _gui = {
        init: function() {
            // three main divs/sections
            this.$chat_rooms    = $('#chat-rooms');
            this.$chat_main     = $('#chat-main');
            this.$chat_users    = $('#chat-users');

            this.$room_name     = $('.room-name');
            this.$rooms_list    = $('#rooms-list');
            this.$user_list     = $('#user-list');
            this.$chat_history  = $('#chat-history');
            this.$chat_input    = $('#chat-text');
            this.$user_count    = $('#chat-main .user-count, #chat-users .user-count');
            this.$status        = $('#status');

            // _gui.show_mobile_chat_main();
            _gui.setup_dom_binds();

            _vent.trigger('Nanoscroller:chat:setup');

            this.ChatUserList = new self.app.views.ChatUserList({
                el: '#user-list',
                collection: _data.users,
                childViewOptions: {
                    event_ns: self.moduleName
                }
            });
            this.ChatUserList.on("render", _util.lazyload);
            this.ChatUserList.render();
        },
        init_vchat: function() {
            this.$chat_history  = $('#chat-history .nano-content');
            this.$chat_input    = $('#video-chat-input');

            this.$chat_users    = $('#chat-users');
            this.$user_list     = $('#user-list');
            this.$room_name     = $('.room-name');
            this.$user_count    = $('#chat-panel .user-count, #chat-users .user-count');

            this.$rooms_list    = $();
            this.$chat_rooms    = $();
            this.$chat_main     = $();
            this.$status        = $();

            this.$video_loading_notice = $('#video-loading-notice');
            this.$video_loading_notice_title = $('#video-loading-notice .text-title');
            this.$video_loading_notice_text  = $('#video-loading-notice .text-notice');

            this.$profile_videochat_wrap = $('#profile-videochat-wrap');

            this.$video_private_notice   = $('#video-private-notice');
            this.$video_private_btn      = $(".go-private-button");
            this.$video_stop_private_btn = $('#stop-private-div');

            this.$camera_select_wrap =  $('#camera-select-wrap');
            this.$camera_select      =  $('#camera-select');

            this.$connection_status_wrap =  $('#connection-status-wrap');
            this.$connection_status_text =  $('#connection-status-text');

            // _gui.show_mobile_chat_main();
            _gui.setup_vchat_binds();
            _events.setup_nanoscroll_vchat();

            _gui.videochat_goal_updated();

            this.ChatUserList = new self.app.views.ChatUserList({
                el: '#user-list',
                collection: _data.users,
                childViewOptions: {
                    event_ns: self.moduleName
                }
            });
            this.ChatUserList.on("render", _util.lazyload);

            _gui.clear_chat_history();
        },
        reset: function() {
            _gui.clear_chat_history();
            _gui.update_current_room_user_count(0);
            _gui.show_mobile_chat_main();

            $init_div = $('<div/>').addClass('js-chat-message chat-init-message').text(js_lang.chat.init_text + '...');
            _gui.$chat_history.append($init_div);
        },
        setup_dom_binds: function() {
            // turn off all chat event handlers, in case we are reconnecting, setting up again without leaving the page
            $("#chat-wrap *").off('.' + _conf.event_namespace);
            $(document).off('.' + _conf.event_namespace);

            // join/leave room click binds
            $(document).on('click.' + _conf.event_namespace, '#rooms-list div', _events.room_clicked);

            // send chat message event binds
            $('#send').on('click.' + _conf.event_namespace, _events.send_chat_message);
            $('#chat-text').on('keyup.' + _conf.event_namespace, function(e) {
                if (e.keyCode === 13) {
                    _events.send_chat_message();
                }
            });

            // collapse/expand rooms/user panes
            $('.tablet #chat-rooms .toggle, .desktop #chat-rooms .toggle, .desktop-wide #chat-rooms .toggle').on(
                'click.' + _conf.event_namespace,
                _gui.toggle_rooms
            );
            $('.tablet #chat-users .toggle, .desktop #chat-users .toggle, .desktop-wide #chat-users .toggle').on(
                'click.' + _conf.event_namespace,
                _gui.toggle_users
            );

            // mobile swap fullscreen views
            $('.mobile #chat-rooms .toggle.mobile, .mobile #chat-users .toggle.mobile').on('click.' + _conf.event_namespace, _gui.show_mobile_chat_main);
            // $('.mobile #chat-users .toggle.mobile').on('click.' + _conf.event_namespace, _gui.show_mobile_chat_main);
            $('.mobile #chat-main  .toggle.mobile.rooms').on('click.' + _conf.event_namespace, _gui.show_mobile_chat_rooms);
            $('.mobile #chat-main  .toggle.mobile.users').on('click.' + _conf.event_namespace, _gui.show_mobile_chat_users);

            // show older/hidden messages that have been hidden due to mobile_history_cap
            $('#mobile-show-history').on('click.' + _conf.event_namespace, _gui.show_mobile_history);
        },
        setup_vchat_binds: function() {
            // turn off all chat event handlers, in case we are reconnecting, setting up again without leaving the page
            $("#video-chat-wrap *").off('.' + _conf.event_namespace);
            $(document).off('.' + _conf.event_namespace);

            // send chat message event binds
            $('#btn-chat-send').on('click.' + _conf.event_namespace, _events.send_chat_message);
            $('#video-chat-input').on('keyup.' + _conf.event_namespace, function(e) {
                if (e.keyCode === 13) {
                    _events.send_chat_message();
                }
            });

            $('.toggle-tip-sound').on('click.' + _conf.event_namespace, function(e) {
                _data.vc.play_tip_sound = !_data.vc.play_tip_sound;
                $(this).is(":checked",_data.vc.play_tip_sound);

            });
            $('.btn-chat-tip').on('click.' + _conf.event_namespace, _events.show_tip_panel);
            $('.btn-send-chat-tip').on('click.' + _conf.event_namespace, _events.send_tip);

            // show older/hidden messages that have been hidden due to mobile_history_cap
            $('#mobile-show-history').on('click.' + _conf.event_namespace, _gui.show_mobile_history);

            $('.tab-chat').on('click.' + _conf.event_namespace, function(e) {
                $('#chat-panel .chat-nav-tabs li').removeClass('active');
                $(this).addClass('active');

                $('#chat-users').hide();
                $('#chat-history').show();
            });
            $('.tab-userlist').on('click.' + _conf.event_namespace, function(e) {
                $('#chat-panel .chat-nav-tabs li').removeClass('active');
                $(this).addClass('active');

                $('#chat-users').show();
                $('#chat-history').hide();

                _gui.ChatUserList.render();
            });

            // update hidden form var whenever tip amount is changed
            $('.tip-select').on('change.' + _conf.event_namespace, function(e) {
                $('#vchat-tip-amount').val(this.value);
            });

            // set hidden form var to first/lowest tip amount by default when setup
            $("#vchat-tip-amount").val($(".tip-select option:first").val());

            // purchase ticket modal
            $(document).on(
                'click.' + _conf.event_namespace,
                '#vc-purchase-ticket-form .modal-action-btn',
                _apis.purchase_ticket
            );
            $(document).on(
                'click.' + _conf.event_namespace,
                '#vc-purchase-ticket-form .js-close-purchase-ticket-modal',
                _apis.close_purchase_ticket
            );
            // request private show
            $(document).on(
                'click.' + _conf.event_namespace,
                '#vc-ppm-form .modal-action-btn',
                _apis.request_private
            );
            $(document).on(
                'change.' + _conf.event_namespace,
                '#set-private-sel',
                _apis.set_private_ppm
            );
            $(document).on(
                'click.' + _conf.event_namespace,
                '#stop-private-button',
                _apis.stop_private
            );


            // cancel ticket show, started or in countdown
            $(document).on(
                'click.' + _conf.event_namespace,
                '#cancel-ticket-button',
                _apis.cancel_ticket_show
            );

            // modal for setting/updating videochat tip goals (add bind to room name/title where tip goal is shown)
            if (_data.vc.is_publisher) {
                $(document).on(
                    'click.' + _conf.event_namespace,
                    '.info-wrap .vc-room-name, .info-wrap .edit-goal',
                    function() { _apis.get_goal_modal(true); }
                );

                // form submit button bind for tip goal modal
                $(document).on(
                    'click.' + _conf.event_namespace,
                    '#vc-goals-form .modal-action-btn',
                    _apis.update_goal_details
                );
                // "no thanks" button bind for tip goal modal
                $(document).on(
                    'click.' + _conf.event_namespace,
                    '#vc-goals-form .js-close-goal-modal',
                    _apis.remove_goal
                );
                // golden ticket modal
                $(document).on(
                    'click.' + _conf.event_namespace,
                    '#vc-ticket-form .modal-action-btn',
                    _apis.start_ticket
                );

                $(document).on(
                    'keydown.' + _conf.event_namespace,
                    '.vc-goals-form-credits',
                    function(event) {
                        let goal_limit = _conf.vc_tip_goal_max;
                        if (_data.membership == 'BRONZE') {
                            goal_limit = _conf.vc_tip_goal_max_bronze;
                        }

                        // ensure that it is a number and stop the keypress if not
                        if (event.key.length === 1 && !/^\d+$/.test(event.key)) {
                            event.preventDefault();
                        }
                        // limit goal to 100k credits (4k for bronze users)
                        var goal_credits_entered = parseInt($(this).val());
                        if (goal_credits_entered > goal_limit) {
                            $(this).val(goal_limit);
                        }
                    }
                );

                // publisher control buttons
                $('#btn-clear-history').on('click.' + _conf.event_namespace, _vchat.clear_history);

                // click event for toggling microphone in publisher video/element
                $('#btn-toggle-mic').on('click.' + _conf.event_namespace, _vchat.toggle_mic);

                // click event for stopping publishing to flussonic
                $('#btn-stop-publish').on('click.' + _conf.event_namespace, function() {
                    // stop publisher object first
                    if (_data.flussonic.pub_obj) {
                        _data.flussonic.pub_obj.stop();
                        _timers.clear(_conf.timer_cps);
                    }

                    // cleanup and reset chat data
                    _vchat.abort();
                });
            }
        },
        show_mic_btn: function() {
            $('#btn-toggle-mic').removeClass('hide');
        },
        show_cam_select: function(cameras) {
            if (cameras.length > 1) {
                _gui.$camera_select.empty().off();
                _gui.$camera_select.append($('<option/>').val('').text('Select Camera'));

                let in_use = false;
                let active_camera = _data.flussonic.active_devices.video;

                for (var i = 0; i < cameras.length; i++) {
                    in_use = (active_camera == cameras[i].deviceId);

                    _gui.$camera_select.append(
                        $('<option/>')
                            .val(cameras[i].deviceId)
                            .text(cameras[i].label)
                            .prop('disabled', in_use)
                    );
                }

                _gui.$camera_select.on('change', function(e) {
                    _vchat.change_camera($(this).val());
                });

                _gui.$camera_select_wrap.removeClass('hide');
            }
        },
        update_mic_btn: function(mic_state) {
            var $btn     = $('#btn-toggle-mic'),
                green    = 'btn-success',
                red      = 'btn-danger',
                mic_on   = 'glyphicon-volume-up',
                mic_off  = 'glyphicon-volume-off';

            if (mic_state == 'on') {
                $btn.removeClass(red).addClass(green);
                $btn.children('.glyphicon').removeClass(mic_off).addClass(mic_on);
            } else {
                $btn.removeClass(green).addClass(red);
                $btn.children('.glyphicon').removeClass(mic_on).addClass(mic_off);
            }
        },
        show_private_sel: function() {
            // don't show private for users streaming from iOS until refresh bug can be sorted out
            if (self.app.Util.check_ios()) {
                return;
            }

            // don't allow user to go private if they're a bronze/credit user
            // TODO: allow bronze users to go private now?
            // if (GP.sdata.my_user.membership == 'BRONZE') {
            //     return;
            // }

            $('#set-private-div').show();
            $('#set-private-sel').val(0);
        },
        hide_private_sel: function() {
            $('#set-private-sel').val(0);
            $('#set-private-sel').trigger("change");

            $('#set-private-div').hide();
        },
        show_ticket_btn: function() {
            _log('show ticket btn called. _data.user: ', _data.user);

            if (_data.user.gender != 'MAN') {
                _log('show ticket btn logic passed... showing button');
                $('#start-ticket-button').show();
            }
        },
        hide_ticket_btn: function() {
            $('#start-ticket-button').hide();
        },
        init_ticket_info: function() {
            _data.vc.ticket_info.msg_shown = false;

            $('.ticket-show-info').html(_data.vc.ticket_info.info);
            $('.ticket-show-cost').html(_data.vc.ticket_info.credit_cost);

            _util.start_ticket_show_timers();
            $('#profile-videochat-wrap').addClass('ticket-show-on');

            if (_data.vc.is_publisher) {
                $('#cancel-ticket-wrap').show();
            }
        },
        close_ticket_info: function() {
            _log('close_ticket_info called... should be removing ticket-show-on class');

            $('#profile-videochat-wrap').removeClass('ticket-show-on');
            $('#video-player').removeClass('ticket-preview');
            $('#cancel-ticket-wrap').hide();
        },
        ticket_start_countdown: function() {
            _log('gui.ticket_start_countdown function fired');
            _trace('gui.ticket_start_countdown... _data.vc: ', _data.vc);

            var _start_text = 'The Ticket Show will start in ',
                _start_time = 0;
            _data.vc.ticket_info.start_time--;

            if (_data.vc.ticket_info.start_time > 0) {
                if (_data.vc.ticket_info.start_time <= 60) {
                    _start_time = _data.vc.ticket_info.start_time + 's';
                    $('.ticket-show-start').html(_start_time);
                    if (!_data.vc.ticket_info.msg_shown) {
                        _gui.add_admin_msg(_start_text + _start_time);
                        _data.vc.ticket_info.msg_shown = true;
                    }
                } else {
                    var minutes = Math.floor(_data.vc.ticket_info.start_time / 60);
                    var seconds = _data.vc.ticket_info.start_time % 60;
                    _start_time = minutes + 'm ' + seconds + 's';
                    $('.ticket-show-start').html(_start_time);
                    if (!_data.vc.ticket_info.msg_shown) {
                        _gui.add_admin_msg(_start_text + _start_time);
                        _data.vc.ticket_info.msg_shown = true;
                    }
                }
            } else {
                _util.clear_ticket_show_timers();

                $('.ticket-show-start').html('<span style="color:green;">Live</span>');
                _gui.add_admin_msg('The Ticket Show has started');

                if (!_data.vc.ticket_info.ticket_paid) {
                    if (!_data.vc.is_publisher) {
                        _vchat.reset_player();
                    }

                    // fetch preview_pic and call vchat_show_ticket_notice on completion or failure
                    _apis.get_stream_preview_pic(_data.vc.room_id, this, _gui.vchat_show_ticket_notice);
                }
            }
        },
        vchat_show_ticket_notice: function(preview_pic) {
            _log('vchat_show_ticket_notice called with preview_pic: ', preview_pic);

            var modal_url = _util.build_ticket_modal_url(),
                css_rules = {
                    "display": "block",
                    "background-color": "#000"
                };

            if (preview_pic) {
                _log('preview_pic found. setting css background');
                css_rules = {
                    "background-image": 'url("' + preview_pic + '")',
                    "background-size":  "cover",
                    "display": "flex"
                };
            } else {
                _log('preview_pic not found. using black background');
            }

            $('#video-ticket-notice').css(css_rules);
            $('#video-ticket-modal-link').attr('href', modal_url);
            $('#video-player').addClass('ticket-preview');
        },
        vchat_started_profile: function() {
            $('.btn-videochat-profile').hide();
            $('.btn-videochat-cancel-wrap').show();

            $('html, body').animate({scrollTop: 0}, 'fast');

            if (_util.is_mobile()) {
                // hide growls on mobile while using videochat
                _vent.trigger('ActivityPane:hide_growls', true);
            } else {
                $(window).scrollTop(0);
            }
        },
        reset_vchat: function() {
            $('#profile-videochat-wrap').hide();
            $('#' + _conf.vchat_player_id).empty();
            $('#' + _conf.vchat_publisher_id).empty();
            $('#' + _conf.vchat_player_wrap).empty();
            $('#' + _conf.vchat_publisher_wrap).empty();

            $('.btn-videochat-profile').show();
            $('.btn-videochat-cancel-wrap').hide();

            // keep the activity carousel hidden on profile.
            if (_current_module_page !== 'user:profile') {
                MoshPit.remove_state('jump-page');
            }
        },
        add_room: function(room, current_room) {
            var $room_div = _gui.templates.get_room_div(room);

            if (current_room) {
                $room_div.addClass('selected');
            }
            _gui.$rooms_list.append($room_div);
        },
        highlight_room: function(room) {
            if (typeof room != 'undefined' && room && room.hasOwnProperty('room_id')) {
                var $room_div = $('#rooms-list #room-' + room.room_id);

                if ($room_div.length) {
                    $room_div.addClass('selected');
                }
            }
        },
        clear_room_list: function() {
            _gui.$rooms_list.empty();
        },
        set_room_name: function(room) {
            _gui.$room_name.empty().append($('<span>' + room.name + '</span>'));
        },
        clear_room_name: function() {
            _gui.$room_name.empty();
        },
        clear_users: function() {
            _gui.$user_list.empty();
        },
        emojify: function(str) {
            return emoji.replace_unified(emoji.replace_colons(str));
        },
        add_chat_message: function(message) {
            _log('gui.add_chat_message called: ', message);

            if (_util.check_blocked_user(message.data.user.duid)) {
                return;
            }

            if (_data.vc.private_room === true) {
                var watcher_duid = _data.vc.private_info.watcher_duid;

                // chat msg received from streamer/publisher or other user (watcher)
                if (message.data.user.duid == _data.vc.room_id || message.data.user.duid == watcher_duid) {
                    // private message
                    if (_data.duid != _data.vc.room_id && _data.duid != watcher_duid) {
                        return;
                    }
                // normal message
                } else if (_data.duid == _data.vc.room_id || _data.duid == watcher_duid) {
                    return;
                }
            }

            var pic = _util.parse_message_for_image(message.data.text);

            if (pic) {
                _gui.add_pic_upload(message.data.user, pic);
                return;
            }

            var tip_msg = _util.parse_message_for_tip(message.data.text);
            if (tip_msg) {
                _gui.add_tip(message.data.user, tip_msg);
                return;
            }

            var deny_msg = _util.parse_message_for_priv_deny(message.data.text);
            if (deny_msg) {
                _gui.add_priv_deny(message.data.user, tip_msg);
                return;
            }

            // emoji.replace_unified(message.data.text);
            var chat_text  = _gui.emojify(message.data.text);

            if (message.data.hasOwnProperty('ticket_paid')) {
                message.data.user.ticket_paid = message.data.ticket_paid;
            }

            var $chat_line = _gui.templates.get_chat_line(message.data.user, chat_text);

            $chat_line
                .addClass(message.data.user.gender.toLowerCase())
                .addClass('js-chat-message');
            _gui.$chat_history.append($chat_line);

            _gui.scroll_chat_history();

        },
        add_chat_history: function(chats) {
            if (typeof chats != 'undefined' && chats) {
                var has_images = false;
                for (var i = 0; i < chats.length; i++) {
                    var chat_tmp = chats[i];

                    // don't include chats from blocked users when loading chat history
                    if (_util.check_blocked_user(chat_tmp.user.duid)) {
                        continue;
                    }

                    var pic = _util.parse_message_for_image(chat_tmp.text);

                    if (pic) {
                        _gui.add_pic_upload(chat_tmp.user, pic, true);
                        has_images = true;
                        continue;
                    }

                    var tip_msg = _util.parse_message_for_tip(chat_tmp.text);
                    if (tip_msg) {
                        _gui.add_tip(chat_tmp.user, tip_msg);
                        continue;
                    }

                    var chat_text  = _gui.emojify(chat_tmp.text); // emoji.replace_unified(chat_tmp.text);
                    var $chat_line = _gui.templates.get_chat_line(chat_tmp.user, chat_text);

                    $chat_line
                        .addClass(chat_tmp.user.gender.toLowerCase())
                        .addClass('js-chat-message');
                    _gui.$chat_history.append($chat_line);
                }

                if (!_data.free_user && typeof _chat_sm_link != 'undefined' && _chat_sm_link) {
                    var $link = $('<a/>').attr({
                        href: _chat_sm_link,
                        target: '_blank',
                        class: 'sm-link'
                    }).text(js_lang.chat.survey_link_text);
                    var $survey_link = _gui.templates.get_chat_line({duid: 69, username: 'Site Master'}, $link);

                    $survey_link.addClass('site-message woman js-chat-message');
                    _gui.$chat_history.append($survey_link);
                }

                if (_util.is_vchat()) {
                    _events.setup_nanoscroll_vchat();
                } else {
                    _vent.trigger('Nanoscroller:chat:setup');
                }


                if (has_images) {
                    _gui.$chat_history.find('img.pic-upload').imagesLoaded(function() {
                        _gui.scroll_chat_history();
                    });
                } else {
                    _gui.scroll_chat_history();
                }
            }
        },
        clear_chat_input: function() {
            _gui.$chat_input.val('');
            _gui.focus_chat_input();
        },
        clear_chat_history: function() {
            // _gui.$chat_history.empty();
            // $('#chat-history > div.js-chat-message').remove();
            this.$chat_history.children('div.js-chat-message').remove();
        },
        focus_chat_input: function() {
            _gui.$chat_input.focus();
        },
        // show hidden chats that were beyond the mobile history cap
        show_mobile_history: function(e) {
            e.preventDefault();

            // $('#chat-history > div.js-chat-message').show();
            this.$chat_history.children('div.js-chat-message').show();
            $(this).hide();
            _data.override_mobile_chat_limit = true;
        },
        update_current_room_user_count: function(count_text) {
            // _log('update_current_room_user_count: ', count_text);
            _gui.$user_count.text('(' + count_text + ')');
        },
        update_rooms_list_user_count: function(room_id, count_text) {
            // _info('update_rooms_list_user_count: ', room_id, count_text);
            $('#rooms-list #room-' + room_id + ' .room-user-count').text('(' + count_text + ')');
        },
        flash_status: function(text) {
            _gui.$status.text(text);
        },
        add_room_event: function(user, evnt_msg) {
            if (typeof user != 'undefined' && user) {
                if (user.hasOwnProperty('override') || ($.inArray(user.gender, _data.seeking) > -1)) {
                    var $chat_message = _gui.templates.get_chat_line(null, evnt_msg).addClass('status-message js-chat-message');
                    _gui.$chat_history.append($chat_message);

                    _gui.scroll_chat_history();
                    _gui.trim_mobile_history();
                }
            }
        },
        add_admin_msg: function(msg) {
            var $chat_message = _gui.templates.get_chat_line(null, msg).addClass('site-message js-chat-message');
            _gui.$chat_history.append($chat_message);

            _gui.scroll_chat_history();
            _gui.trim_mobile_history();
        },
        add_error_msg: function(error_msg) {
            var $chat_message = _gui.templates.get_chat_line(null, error_msg).addClass('status-message has-error js-chat-message');
            _gui.$chat_history.append($chat_message);

            _gui.scroll_chat_history();
            _gui.trim_mobile_history();
        },
        add_pic_upload: function(user, pic_url, skip_images_loaded) {
            if (typeof pic_url == 'undefined' || !pic_url) {
                return;
            }
            var $chat_line, $tmp_div;
            var uploader_duid = (user && user.duid) ? user.duid : null;
            var $chat_message = _gui.templates.get_chat_img_ele(pic_url, uploader_duid);

            // hide image if user is in safemode and not their own pic
            var self_pic = (user.duid == _data.duid),
                safemode = GP.sdata.my_user.pg;

            // user posting pic is not logged in user and not of a gender the user is seeking
            // or they are in safemode so we hide and replace with button to show
            if (!self_pic && (safemode || $.inArray(user.gender, _data.seeking) === -1)) {
                $tmp_div   = _gui.templates.get_pic_buttons($chat_message);
                $chat_line = _gui.templates.get_chat_line(user, $tmp_div);
            } /* else if (user.duid != _data.duid && $.inArray(user.gender, _data.seeking) === -1) {
                var $tmp_div = _gui.templates.get_pic_buttons($chat_message);
                $chat_line = _gui.templates.get_chat_line(user, $tmp_div);
            } */ else {
                $chat_line = _gui.templates.get_chat_line(user, $chat_message);
            }

            $chat_line.addClass(user.gender.toLowerCase()).addClass('chat-pic js-chat-message');
            if (skip_images_loaded !== true) {
                $chat_message.find('img').imagesLoaded(function() {
                    _gui.scroll_chat_history();
                });
            }
            _gui.$chat_history.append($chat_line);

            if (skip_images_loaded === true) {
                _gui.scroll_chat_history();
            }
        },
        add_tip: function(user, message) {
            if (typeof message == 'undefined' || !message) {
                return;
            }

            var $chat_line = _gui.templates.get_chat_line(user, message, true);

            $chat_line
                .addClass(user.gender.toLowerCase())
                .addClass('js-chat-message tip-message');
            _gui.$chat_history.append($chat_line);
            _gui.scroll_chat_history();
        },
        show_priv_deny: function(user, message) {
            if (typeof message == 'undefined' || !message) {
                return;
            }

            var $chat_line = _gui.templates.get_chat_line(user, message, true);

            $chat_line
                .addClass(user.gender.toLowerCase())
                .addClass('js-chat-message tip-message');
            _gui.$chat_history.append($chat_line);
            _gui.scroll_chat_history();
        },
        videochat_goal_updated: function() {
            if (!$.isEmptyObject(_data.vc.tip_goal)) {
                var name             = _data.vc.tip_goal.title,
                    name_short       = _util.truncate(name),
                    goal_credits     = _data.vc.tip_goal.credits,
                    goal_progress    = _data.vc.tip_goal.progress,
                    progress_percent = 0,
                    width_percent    = 0;


                $('#video-panel .vc-room-name')
                    .attr('title', name)
                    .html('<strong>[' + _util.number_with_commas(goal_credits) + ' credits] ' + name_short + '</strong>');

                var $goal_progress = $('#chat-panel .goal-progress'),
                    $received = $goal_progress.find('.details .received'),
                    $goal     = $goal_progress.find('.details .goal'),
                    $progress_bar = $goal_progress.find('#tip-goal-progressbar .progress-completed');

                $received.text(_util.number_with_commas(goal_progress));
                $goal.text(_util.number_with_commas(goal_credits));

                if (goal_progress) {
                    progress_percent = Math.round(((goal_progress / goal_credits) * 100));
                    width_percent    = ((progress_percent > 100) ? 100 : progress_percent);

                    $progress_bar.css('width', width_percent + '%');
                } else {
                    $progress_bar.css('width', '0%');
                }

                $goal_progress.removeClass('hide');
            }
        },
        // fill in the goal form if we have data already (i.e. updating/changing the goal details etc...)
        videochat_goal_modal_opened: function() {
            if (!$.isEmptyObject(_data.vc.tip_goal)) {
                $("#vc-goals-form input[name='title']").val(_data.vc.tip_goal.title);
                $("#vc-goals-form input[name='credits']").val(_data.vc.tip_goal.credits);
            }
        },
        hide_all: function() {
            MoshPit.remove_state('mobile-chat-main').remove_state('mobile-chat-users');
            _gui.$chat_rooms.hide();
            _gui.$chat_main.hide();
            _gui.$chat_users.hide();
        },
        show_mobile_chat_rooms: function(from_pop_state) {
            if (!_util.is_mobile() || _data.vc.room_id) {
                return;
            }
            _gui.hide_all();

            if (from_pop_state !== true) {
                var state = {
                    chat: "chat-rooms"
                };
                _vent.trigger("Page:push_state", state);
            }
            MoshPit.add_state('mobile-chat-rooms');
            _gui.$chat_rooms.show();

            $('html, body').animate({scrollTop: 0}, 'fast');
        },
        show_mobile_chat_main: function(from_pop_state) {
            if (!_util.is_mobile() || _data.vc.room_id) {
                return;
            }
            _gui.hide_all();

            if (from_pop_state !== true) {
                var state = {
                    chat: "chat-main"
                };
                _vent.trigger("Page:push_state", state);
            }
            MoshPit.add_state('mobile-chat-main');
            _gui.$chat_main.show();

            $('html, body').animate({scrollTop:$(document).height()}, 'fast');
        },
        show_mobile_chat_users: function(from_pop_state) {
            if (!_util.is_mobile() || _data.vc.room_id) {
                return;
            }

            // if (_util.current_room_id() === 0) {
            //     _events.init_chat();
            // }

            _gui.hide_all();
            MoshPit.add_state('mobile-chat-users');
            _gui.$chat_users.show();
            $('html, body').animate({scrollTop: 0}, 'fast');

            // loop through the first 25 users and make sure the thumbnail shows if needed
            $('#user-list .chat-user:lt(25) img[src=""]').each(function() {
                var $img = $(this);
                var img_src = $img.data('original');
                if (img_src) {
                    $img.attr('src', img_src);
                }
            });

            if (from_pop_state !== true) {
                var state = {
                    chat: "chat-users"
                };
                _vent.trigger("Page:push_state", state);
            }
        },
        toggle_rooms: function(e) {
            MoshPit.toggle_state('chat-rooms-collapsed');

            if (MoshPit.has_state('chat-rooms-collapsed')) {
                $(this).html('&raquo;');
            } else {
                $(this).html('&laquo;');
            }
        },
        toggle_users: function(e) {
            MoshPit.toggle_state('chat-users-collapsed');

            if (MoshPit.has_state('chat-users-collapsed')) {
                $(this).html('&laquo;');
            } else {
                $(this).html('&raquo;');
            }
        },
        scroll_chat_history: function() {
            // scroll chat history to the bottom if we haven't scrolled up and flagged the suppress_scroll flag
            if (!_data.suppress_scroll) {
                _gui.reset_history_nanoscroll();

                if (_util.chk_chat_vchat(true)) {
                    _gui.scroll_mobile_viewport();
                }
            }
        },
        scroll_mobile_viewport: function() {
            if (_util.is_mobile() && !$('body').hasClass('mobile-menu-open') && !$('body').hasClass('right-drawer-shown')) {
                $('html, body').animate({scrollTop: GP.Util.get_doc_height()}, 'fast');

                if (!_data.mobile_height_check) {
                    // var chat_height = $("#chat-history").height() + 50;
                    var chat_height = this.$chat_history.height();
                    var body_height = $("body").height();

                    if (chat_height > body_height) {
                        _data.mobile_height_check = true;

                        // reset height 100% when the height is larger than the screen
                        $('#main, #main-content, #page').css('height', 'auto');
                    }
                }
            }
        },
        trim_mobile_history: function() {
            if (_util.is_mobile() && !_data.override_mobile_chat_limit && !_data.suppress_scroll) {
                // var chat_history_length = $('#chat-history > div.js-chat-message').length;
                var chat_history_length = this.$chat_history.children('div.js-chat-message').length;

                if (chat_history_length > _conf.mobile_history_cap) {
                    $('#mobile-show-history').css('display', 'block');
                    var index = (chat_history_length - _conf.mobile_history_cap);
                    // $('#chat-history > div.js-chat-message').slice(0, index).hide();
                    this.$chat_history.children('div.js-chat-message').slice(0, index).hide();
                }
            }
        },
        reset_history_nanoscroll: function() {
            // mobile won't have the .nano class, so no need to check for mobile
            var $scroll_container = $('#chat-main .nano, #video-chat-wrap .nano');
            $scroll_container.nanoScroller();
            $scroll_container.nanoScroller({ scroll: 'bottom'});
        },
        reset_userlist_nanoscroll: function() {
            // mobile won't have the .nano class, so no need to check for mobile
            $('#chat-users .nano').nanoScroller();
        },
        hide_blocked_users_activity: function() {
            if (_data.blocked_users && _data.blocked_users.length) {
                var bl_duid;
                $.each(_data.blocked_users, function(i, user) {
                    bl_duid = parseInt(user.duid, 10);

                    // check that parseInt returned a proper integer for use to work with
                    if (_.isFinite(bl_duid)) {
                        if (_gui.$chat_main) {
                            // hide any chats from blocked user in the chat history
                            _gui.$chat_main.find("div.js-chat-message[data-duid='" + bl_duid + "']").hide();
                        }

                        if (_gui.$chat_history) {
                            // hide any chats from blocked user in the chat history
                            _gui.$chat_history.find("div.js-chat-message[data-duid='" + bl_duid + "']").hide();
                        }

                        // remove user from users collection in the user list
                        _data.users.remove(bl_duid);
                    }
                });
            }
        },
        templates: {
            get_chat_line: function(user, message, is_tip) {
                is_tip = (typeof is_tip !== 'undefined') ? is_tip : false;

                var author = '';
                if (user && user.username) {
                    author += (user && user.ticket_paid) ? '[Ticket] ' : '';
                    author += is_tip ? user.username + ' ' : user.username + ': ';
                }

                var $chat_outer = $('<div/>');
                var $chat_div   = $('<div/>', {'class' : 'msg-ct'});

                var profile_url = '#';
                if (user && user.duid) {
                    profile_url = _util.get_profile_url(user.duid);
                    $chat_outer.attr('data-duid', user.duid);
                }

                var link_options = {
                    href:   profile_url,
                    title:  author
                };
                if (!_data.free_user) {
                    link_options.target = '_blank';
                }
                var $user = $('<a/>').attr(link_options).addClass('author').text(author);
                var $text_ele;
                if (message instanceof jQuery) {
                    $text_ele = $('<span/>').addClass('text').append(message);
                } else {
                    $text_ele = $('<span/>').addClass('text').html(message);
                }

                $chat_div.append($user).append($text_ele);

                // add extra wrapper div
                $chat_outer.append($chat_div);

                return $chat_outer;
            },
            get_pic_buttons: function($img) {
                $img.addClass('hide');

                $button = $('<button/>').addClass('btn btn-primary btn-xs').text(js_lang.chat.show_pic)
                          .on('click', function(e) {
                              $(this).hide().siblings().removeClass('hide');
                              _gui.scroll_chat_history();
                          });
                $div = $('<div/>').addClass('text').append($img).append($button);
                return $div;
            },
            get_chat_img_ele: function(pic_url, duid) {
                if (typeof pic_url == 'undefined' || !pic_url) {
                    return $('<div/>');
                }

                var src_url  = pic_url.replace(_conf.large_pic_re, '-M.jpg');
                var link_url = pic_url.replace(_conf.medium_pic_re, '-L.jpg');

                var height = 0;
                if (pic_url.indexOf('?') > -1) {
                    var tmp = pic_url.split('?');
                    height = parseInt(tmp[1], 10);
                }

                var $img_div = $('<img/>').attr({
                    src:   src_url,
                    class: 'pic-upload'
                });

                if (height > 0) {
                    $img_div.height(height);
                }

                $img_div.on('click', function(e) {
                    e.preventDefault();

                    if (_data.free_user) {
                        _vent.trigger('Page:billing_redirect', duid);
                    } else {
                        window.open(link_url, '_blank');
                    }
                });
                return $img_div;
            },
            get_room_div: function(room) {
                if (typeof room != 'undefined' && room) {
                    var $room_div   = $('<div/>').attr('id', 'room-' + room.room_id).data('room-id', room.room_id);
                    var $room_name  = $('<span/>').text(room.name);
                    var $user_count = $('<span/>').addClass('room-user-count').text('(' + room.user_count + ')');
                    $room_div.append($room_name).append($user_count);
                    return $room_div;
                }
                return $('<div/>');
            },
        },
        show_loading_notice: function(title, msg) {
            // _trace('gui.show_loading_notice called. title: ', title);
            _log('gui.show_loading_notice. msg: ', msg);

            if (typeof title != 'undefined' && title) {
                _gui.$video_loading_notice_title.text(title);
            } else {
                var orig_title = _gui.$video_loading_notice_title.data('init-text');
                _gui.$video_loading_notice_title.text(orig_title);
            }
            if (typeof msg != 'undefined' && msg) {
                _gui.$video_loading_notice_text.text(msg);
            } else {
                var orig_msg = _gui.$video_loading_notice_text.data('init-text');
                _gui.$video_loading_notice_text.text(orig_msg);
            }
            _gui.$video_loading_notice.addClass('shown');
            _gui.$video_loading_notice.find('.spinner-wrap').spin({color:'#fff'});
        },
        hide_loading_notice: function() {
            // _gui.$video_loading_notice.removeClass('shown');
            // _gui.$video_loading_notice.find('.spinner-wrap').spin(false);
            $('#video-loading-notice').removeClass('shown').find('.spinner-wrap').spin(false);
        },
        show_private_notice: function() {
            _gui.$video_private_notice.show();
        },
        hide_private_notice: function() {
            _gui.$video_private_notice.hide();
        },
        show_private_btn: function() {
            _trace('gui.show_private_btn called...');

            if (_data.vc.ppm_cost > 0) {
                var modal_url = GP.Util.clean_url('members/videochat/start_private_modal', {
                    ppm_cost:      _data.vc.ppm_cost,
                    streamer_duid: _data.vc.room_id
                });

                $("#video-chat-wrap, #video-chat-footer-wrap").addClass('private-active');
                $("#go-private-url").attr('href', modal_url);
                _gui.$video_private_btn.show();
            }
        },
        hide_private_btn: function() {
            _trace('gui.hide_private_btn called...');

            if (_gui.$video_private_btn) {
                _gui.$video_private_btn.hide();
                $("#video-chat-wrap, #video-chat-footer-wrap").removeClass('private-active');
            }
        },
        private_started: function() {
            _trace('gui.private_started called...');

            _gui.hide_private_notice();
            _gui.$video_private_btn.hide();
            _gui.$video_stop_private_btn.show();
        },
        private_stopped: function() {
            _trace('gui.private_stopped called...');

            _gui.hide_private_notice();
            _gui.$video_stop_private_btn.hide();
        },
        show_connection_status: function() {
            _gui.$connection_status_wrap.show();
        },
        hide_connection_status: function() {
            _gui.$connection_status_wrap.hide();
        }

    };

});

